import http from './http';
import { handleResponse } from '@/shared/utils/promise-helpers';

export const getChatQueueById = (queueId) =>
  http.get(`/queues/chat/${queueId}`).then(handleResponse);

export const getMessagesToday = (identifier) =>
  http
    .get('/chat/messages/history/today', { params: { identifier } })
    .then(handleResponse);

export const qualifyJob = (qualification) =>
  http.post('/job/chat/qualify', qualification).then(handleResponse);

export const closeChatJob = (close) =>
  http.post('/job/chat/close', close).then(handleResponse);

export const sendMessage = (message) =>
  http.post('/chat/messages', message).then(handleResponse);

export const chatTyping = (typingEvent) =>
  http.post('/chat/typing', typingEvent).then(handleResponse);

export const getAgentsAvaibleChatQueue = (queueNumber, agentId) =>
  http
    .get(`/queues/${queueNumber}/chat/agents-available`, {
      params: { agentId },
    })
    .then(handleResponse);

export const getQueues = () => http.get('/queues/chat').then(handleResponse);

export const getQueuesByOrg = (org) =>
  http.get(`/queues/chat/org-unit/${org}`).then(handleResponse);

export const transfer = (job) =>
  http.post('/job/chat/transfer', job).then(handleResponse);
